/**
 * @file button.ts
 * @description
 * -----------------------------------------------------
 * Constante que contiene las constantes de los botones
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-09-01
 * @author Correcta
 * @author Mohammed Derfoufi
 * @copyright © Correcta
 * @license Private
 */

export const BUTTON_STATUS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  DETAILS: "details",
  OUTLINE: "outline",
  OUTLINE_ERROR: "outline--error",
  WARNING_OUTLINE: "warning-outline",
  NO_OUTLINE: "no-outline",
  ERROR: "error",
  DANGER: "danger",
  ACCESS: "access",
  DISABLED: "disabled",
  WHITE: "white",
  CANCEL: "cancel",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
  COOKIES: "cookies",
  CHATBOT: "chatbot",
  TOPBAR: "topbar",
  ICON: "icon",
  SELECT: "select",
  BLOCKED: "blocked",
  EMPTY: "",
  NONE: "none",
  SMALL: "small",
};

export const TYPE_BUTTON = "button";

export const TYPE_SUBMIT = "submit";

export const ICONPOSITION_LEFT = "left";

export const ICONPOSITION_RIGHT = "right";
